module.exports = {
	general: {},
	components: {
		lightcase: {
			errorMessage: 'Das Bild konnte nicht geladen werden.',
			sequenceInfo_of: ' von ',
			close: 'Schliessen',
			prev: 'Vorherige',
			next: 'Nächste',
			play: 'Abspielen',
			pause: 'Pause'
		},
		mmenu: {
			search: {
				placeholder : 'Search menu',
				noresult : 'No result.',
			}
		}
	}
};


/** WEBPACK FOOTER **
 ** ./src/lang/fr.lang.js
 **/